import CityPageTemplate from "../city-template/CityPageTemplate";
import { hooksettConfig } from "./data";

export default function HooksettPage() {
  return <CityPageTemplate config={hooksettConfig} />;
}